import * as React from 'react';
import { connect } from 'react-redux';

import { Container } from '../../components/Container';
import { SIZE_20 } from '../../constants/sizes';

import { IApplicationState } from '../../types/redux';

import { QuickLinksColumnsContainer } from './QuickLinksColumnsContainer';
import { loadPageWithNewJsonQuery } from '../../actions/location';
import { TTypedThunkDispatch } from '../../types/thunk';
import { IBreadcrumb, IQuickLink } from '../../types/offersData';
import { IRoomCounter, IBuildingStatus } from '../../types/newbuilding';
import { trackingActionClickAlsoLooking } from '../../actions/analytics';
import { BuilderBuildingStatuses } from './BuilderBuildingStatuses';
import { BuilderStatsByRooms } from './BuilderStatsByRooms';
import { getIsFilterUpcomingSaleEnabled } from '../../selectors/location';

interface IQuickLinksComponentStoreProps {
  quickLinks: IQuickLink[] | null;
  breadcrumbs: IBreadcrumb[];
  title: string;
  subtitles?: string[];
  buildingStatus: IBuildingStatus[] | null;
  countsByRoom: IRoomCounter[] | null;
  isInfoSection?: boolean;
}

interface IQuickLinksComponentDispatchProps {
  setPage(url: string): void;
}

export type TQuickLinksComponentProps = IQuickLinksComponentStoreProps & IQuickLinksComponentDispatchProps;

export const QuickLinksComponent: React.FunctionComponent<TQuickLinksComponentProps> = props => {
  const { quickLinks, setPage, buildingStatus, countsByRoom } = props;

  const hasQuickLinks = !!quickLinks && !!quickLinks.length;
  const hasBuildingStatus: boolean = !!buildingStatus && !!buildingStatus.length;
  const hasCountsByRoom: boolean = !!countsByRoom && !!countsByRoom.length;
  const hasStats = hasBuildingStatus && hasCountsByRoom;

  return (
    <Container dataMark="QuickLinksComponent" padding={`0 0 ${hasQuickLinks ? SIZE_20 : 0}`} noPrint>
      {!hasStats && <QuickLinksColumnsContainer quickLinks={quickLinks} setPage={setPage} />}
      {hasBuildingStatus && <BuilderBuildingStatuses statuses={buildingStatus} setPage={setPage} />}
      {hasCountsByRoom && <BuilderStatsByRooms counters={countsByRoom} setPage={setPage} />}
    </Container>
  );
};

export function mapStateToProps(state: IApplicationState): IQuickLinksComponentStoreProps {
  const { seo, quickLinks, breadcrumbs, builder, builderStats } = state.offersData;

  const ifNoBuilder = seo && seo.h1 ? seo.h1 : 'Квартиры в новостройках (ЖК) в Москве';
  const title = builder ? `Новостройки от застройщика ${builder.name}` : ifNoBuilder;
  const subtitles = seo?.subtitles;

  return {
    isInfoSection: getIsFilterUpcomingSaleEnabled(state),
    quickLinks: (quickLinks && quickLinks.links) || null,
    countsByRoom: (builderStats && builderStats.countsByRoom) || null,
    buildingStatus: (builder && builder.buildingStatus) || null,
    breadcrumbs,
    title,
    subtitles,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IQuickLinksComponentDispatchProps {
  return {
    setPage: (url: string) => {
      dispatch(trackingActionClickAlsoLooking(url));
      dispatch(loadPageWithNewJsonQuery(url));
    },
  };
}

export const QuickLinksContainer = connect(mapStateToProps, mapDispatchToProps)(QuickLinksComponent);
